import axios from 'axios'
import moment from 'moment'
import store from '@/store'
import router from '@/router'

//
import { getCookieValue } from '@/utils/cookie'
//
const service = axios.create({
    //  baseURL: process.env.VUE_APP_API_BASE_URL,
    //  timeout: process.env.VUE_APP_API_TIMEOUT,
    withCredentials: true
})

service.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

service.interceptors.request.use(async (config) => {
    config.headers['X-XSRF-TOKEN'] = getCookieValue('XSRF-TOKEN')

//    await db.getToken().then(token => {
//        config.headers['Authorization'] = 'Bearer ' + token
//    })

    const params = config.params || {}
    if (params['SILENT']) {
        return config
    }

    config.request_at = new moment().format('Y-MM-DDTHH:mm:ss.SSS')
    config.withCredentials = true
    store.dispatch('axios/request', config)

    return config
})

service.interceptors.response.use(response => {
    store.dispatch('axios/response', response)

    try {
        let text = null
        text = response.data && response.data.message ? response.data.message : null
        if (text) {
            store.dispatch('notification/push', { color: 'success', text: text, })
        }
    } catch (e) {
    }

    return response
}, (error) => {
    if (typeof error.config.data === 'string') {
        error.config.data = JSON.parse(error.config.data)
    }

    store.dispatch('axios/response', error)

    if (error.config.url === store.state.auth.URL_AUTH_ME && (router.currentRoute.meta.auth_level || '000') === '000') {
        return
    }

    let text = null
    if (!error.response) {
        // offline
        text = 'ネットワークが不安定です。接続状況をご確認ください。'
    } else {
        text = error.response.data && error.response.data.message ? error.response.data.message : null
        switch (error.response.status) {
            case 403:
                // auth
                break
            case 422:
                // validation
                break
            case 500:
                // system
                break
        }
    }
    store.dispatch('notification/push', { color: 'danger', text: text, })

    throw error
})

export default service

